import { render } from "./TheBrowser.vue?vue&type=template&id=6f4c5bae&scoped=true"
import script from "./TheBrowser.vue?vue&type=script&lang=js"
export * from "./TheBrowser.vue?vue&type=script&lang=js"

import "./TheBrowser.vue?vue&type=style&index=0&id=6f4c5bae&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4c5bae"]])

export default __exports__